import JoditEditor from 'jodit-react'
import { useMemo } from 'react'

/** @param {import('react').ComponentProps<typeof JoditEditor>} props */
const BundledEditor = (props) => {
  const config = useMemo(
    () => ({
      height: Math.max(300, window.innerHeight - 500),
      zIndex: 1100,
      style: {
        fontFamily: 'Helvetica,Arial,sans-serif',
        fontSize: '14px'
      },
      // Keep HTML source editing local instead of loading Ace from a CDN.
      sourceEditor: 'area',
      buttons: [
        'undo',
        'redo',
        '|',
        'paragraph',
        '|',
        'bold',
        'italic',
        'underline',
        'brush',
        '|',
        'align',
        'ul',
        'ol',
        'outdent',
        'indent',
        '|',
        'link',
        'image',
        'table',
        '|',
        'eraser',
        'source',
        'fullsize'
      ]
    }),
    []
  )

  return <JoditEditor config={config} {...props} />
}

export default BundledEditor
